/**
 * @copyright Copyright (c) 2022 Jonas Rittershofer <jotoeri@users.noreply.github.com>
 *
 * @author Jonas Rittershofer <jotoeri@users.noreply.github.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { translate, translatePlural } from '@nextcloud/l10n'
import Vue from 'vue'

import FormsEmptyContent from './FormsEmptyContent.vue'

Vue.prototype.t = translate
Vue.prototype.n = translatePlural

export default new Vue({
	 el: '#content',
	 // eslint-disable-next-line vue/match-component-file-name
	 name: 'FormsEmptyContent',
	 render: h => h(FormsEmptyContent),
})
